import React from 'react';
import classNames from 'classnames/bind';
import styles from './Info.module.css';

const cx = classNames.bind(styles);

function Info() {
  return (
    <div className={cx('info')}>
      <h3 className={cx('info-title')}>Xanh 19</h3>
      <p className={cx('info-desc')}>Xe ghép Việt - Trì Hà Nội</p>

      <div className={cx('pricing')}>
        <h4>Giá Vé thông thường</h4>
        <p>Thứ 2 - Thứ 5: 150k</p>
        <p>Thứ 6 - Chủ Nhật: 180k</p>
        <p>Bao Xe:</p>
        <ul>
          <li>Thứ 2 - Thứ 5: 500k</li>
          <li>Thứ 6 - Chủ Nhật: 600k</li>
        </ul>
        <p className={cx('route-info')}>
          Việt Trì ⇔ Hà Nội - Đưa Đón Tận Nơi
        </p>
      </div>

      <div className={cx('features')}>
        <h4>Đặc điểm nổi bật</h4>
        <ul>
          <li>Giá hợp lý – Dịch vụ tận tâm</li>
          <li>Xe điện sang trọng – Trải nghiệm êm ái</li>
          <li>Nhận khuyến mãi nhanh chóng, thanh toán tiện lợi</li>
          <li>Đúng giờ – Không lo trễ hẹn</li>
        </ul>
      </div>
    </div>
  );
}

export default Info;